import React, { useEffect, useState } from 'react'
import { useYonghuListQuery } from '../../store/DianShangYeWuApi';
import { Form, Select } from 'antd';

function UserSelect(props) {
    const [list,setList] = useState();
    const {data, isSuccess} = useYonghuListQuery({yh_qy_id:props.qy_id});
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                const newArr = data.Result.map((item) => {
                    const {yh_id,yh_name }=item;
                    return item = {value:yh_id,label:yh_name,key:yh_id}
                })
                setList(newArr)
            }
        }
    },[data,isSuccess])
    return (
        <Form.Item 
                name={props.name}
                label={props.label} 
                required={props.required}  
                style={props.formStyle}
                wrapperCol={props.wrapperCol}
                labelCol={props.labelCol}
            >
                <Select
                    options={list} 
                    onChange={(value, option) => {
                        if(option && props.onChange){
                            if(typeof props.onChange === 'function'){
                                const optionObj = Array.isArray(option) ? option[0] : option;
                                if(optionObj && optionObj.value){
                                    // 传递对象格式，包含 yh_id 和 yh_name
                                    props.onChange({
                                        yh_id: optionObj.value,
                                        yh_name: optionObj.label
                                    });
                                }
                            }
                        }
                    }}
                    defaultValue={props.defaultId}
                    placeholder={props.placeholder}
                    style={props.style}
                    allowClear
                    onClear={() => {
                        if(props.onClear) {
                            props.onClear();
                        }
                        if(props.onChange) {
                            // 清空时也调用 onChange，传递 null 或空对象
                            props.onChange(null);
                        }
                    }}
                    disabled={props.disabled}
                />                        
            </Form.Item>
    )
}

export default UserSelect
